<template>
    <div v-cloak>
      <div class="app-menu" v-if="showTopMenu">
        <div v-if="isPc()" class="app-menu-pc">

          <a v-if="false" class="page_logo" href="/">
            <img v-if="showTopMenu == 'white' " class="page_logo_white" src="https://static-image.xfz.cn/1628943750731/logo_fz_white.png" alt="logo">
            <img v-if="showTopMenu == 'red' " class="page_logo_red" src="./assets/img/pc/fz_red_logo.png" alt="logo">
          </a>

          <div v-if="false" class="page_right_top_menu" @click="toggleRightMenu()">
            <img src="https://static-image.xfz.cn/1628999132570/icon_menu.jpg" alt="menu">
          </div>

          <div class="page-menu-mask" v-if="showRightMenu">
            <div class="menu-close" @click="toggleRightMenu()"> <img src="./assets/img/pc/close.png" alt=""></div>
            <ul id="page-menu-mask-ul">
              <li :class="{ 'li-active' :currentMenu == '/about' }" class="about"><a href="/about">关于凡卓</a></li>
              <li :class="{ 'li-active' :currentMenu == '#team' } " class="team"><a href="/#team">凡卓团队</a></li>
              <li :class="{ 'li-active' :currentMenu == '/deal' }" class="deal"><a href="/deal">凡卓交易</a></li>
              <li :class="{ 'li-active' :currentMenu == '/viewpoint'}" class="viewpoint"><a href="/viewpoint">凡卓观点</a></li>
              <li :class="{ 'li-active' :currentMenu == '/empower' }" class="empower"><a href="/empower">凡卓赋能</a></li>
              <li :class="{ 'li-active' :currentMenu == '/news' }" class="news"><a href="/news">新闻中心</a></li>
              <li :class="{ 'li-active' :currentMenu == '/contact' }" class="contact"><a href="/contact">联系我们</a></li>
            </ul>
          </div>


        </div>
        <div v-else class="app-menu-mobile">
          <a class="page_logo" href="/">
            <img v-if="showTopMenu == 'white' " class="page_logo_white" src="./assets/img/mobile/fz_logo_white.png" alt="logo">
            <img v-if="showTopMenu == 'red' " class="page_logo_red" src="./assets/img/mobile/fz_logo_red.png" alt="logo">
          </a>

          <div class="page_right_top_menu" @click="toggleRightMenu()">
            <img v-if="showTopMenu == 'white'" src="./assets/img/mobile/menu_icon_white.png" alt="menu">
            <img v-if="showTopMenu == 'red'" src="./assets/img/mobile/menu_icon_red.png" alt="menu">
          </div>


          <div class="page-menu-mask" v-if="showRightMenu">
            <div class="menu-close" @click="toggleRightMenu()"> <img src="./assets/img/pc/close.png" alt=""></div>
            <ul id="page-menu-mask-ul">
              <li :class="{ 'li-active' :currentMenu == '/about' }" class="about"><a href="/about">关于凡卓</a></li>
              <li :class="{ 'li-active' :currentMenu == '#team' } " class="team"><a href="/#team">凡卓团队</a></li>
              <li :class="{ 'li-active' :currentMenu == '/deal' }" class="deal"><a href="/deal">凡卓交易</a></li>
              <li :class="{ 'li-active' :currentMenu == '/viewpoint'}" class="viewpoint"><a href="/viewpoint">凡卓观点</a></li>
              <li :class="{ 'li-active' :currentMenu == '/empower' }" class="empower"><a href="/empower">凡卓赋能</a></li>
              <li :class="{ 'li-active' :currentMenu == '/news' }" class="news"><a href="/news">新闻中心</a></li>
              <li :class="{ 'li-active' :currentMenu == '/contact' }" class="contact"><a href="/contact">联系我们</a></li>
            </ul>
          </div>
        </div>
      </div>
      <router-view class="view" keep-alive transition transition-mode="out-in"></router-view>

      <Footer/>
    </div>
</template>
<script>

import Footer from './components/common/Footer.vue'
import util from './assets/js/util'


export default {
  name: 'app',
  components: {
    Footer,
  },
  data() {
    return {
      showTopMenu: "",
      showRightMenu: false,
      currentMenu: '',
    }
  },
  methods: {
    isPc(){
      return screen.width > 800 ? true: false;
    },
    initRouter() {
      var path = this.$router.currentRoute.path
      // console.log("path ----> " + path)
      // console.log("-- query -->" + JSON.stringify(this.$route.query))

      if (path == '/') {
        this.showTopMenu = ""
      } else {
        this.showTopMenu = true
      }
      if (path.indexOf('/article/') > -1) {
        path = '/article/'
      }

      var map = {
        "/": "",
        "/about": "white",
        "/deal": "white",
        "/empower": "white",
        "/news": "white",
        "/article": "red",
        "/viewpoint": "white",
        "/contact": "white",

        "/about/": "white",
        "/deal/": "white",
        "/empower/": "white",
        "/news/": "white",
        "/article/": "red",
        "/viewpoint/": "white",
        "/contact/": "white",
      }
      // this.showTopMenu = map[path]
    },

    initWechatShare() {
      var path = this.$router.currentRoute.path

      var wxshare = {}
      var title = {}
      switch(path) {
        case '/':
          wxshare.title = '凡卓集团'
          wxshare.des = '陪伴创业者从平凡到卓越'
          title.pc = '凡卓集团，陪伴创业者从平凡到卓越'
          title.mobile= '凡卓集团'
        break;

        case '/about':
        case '/about/':
          wxshare.title = '凡卓集团'
          wxshare.des = '陪伴创业者从平凡到卓越'
          title.pc = '凡卓集团-关于我们'
          title.mobile= '凡卓集团-关于我们'
        break;

        case '/service':
        case '/service/':
          wxshare.title = '凡卓集团'
          wxshare.des = '陪伴创业者从平凡到卓越'
          title.pc = '凡卓集团-小饭桌创服'
          title.mobile= '凡卓集团-小饭桌创服'
        break;

        case '/investment':
        case '/investment/':
          wxshare.title = '凡卓集团-小饭桌创投'
          wxshare.des = '专注服务于新经济领域的成长期、成熟期公司'
          title.pc = '凡卓集团-小饭桌创投'
          title.mobile= '凡卓集团-小饭桌创投'
        break;

        case '/fa':
        case '/fa/':
          wxshare.title = '凡卓资本'
          wxshare.des = '为创业者提供全方位一站式融资服务'
          title.pc = '凡卓集团-凡卓资本'
          title.mobile= '凡卓集团-凡卓资本'
        break;

        case '/news':
        case '/news/':
          wxshare.title = '动态新闻'
          wxshare.des = '追求卓越的创业者投融资服务机构'
          title.pc = '凡卓集团-动态新闻'
          title.mobile= '凡卓集团-动态新闻'
        break;

        case '/join':
        case '/join/':
          wxshare.title = '加入我们'
          wxshare.des = '加入我们'
          title.pc = '凡卓集团-加入我们'
          title.mobile= '凡卓集团-加入我们'
        break;
      }

      // console.log('-------------wxshare ---->' + JSON.stringify(wxshare))
      if (this.isPc()) {
        document.title = title.pc || '凡卓集团'
      } else {
        document.title = title.mobile || '凡卓集团'
      }

      $(document).ready(function() {
        // util.getWx(wxshare) todo
      })

    },

    toggleRightMenu() {
      this.showRightMenu = !this.showRightMenu;
      this.currentMenu = this.$router.currentRoute.path
    },

  },
  mounted(){
    this.initRouter()
    this.initWechatShare()

  },

  watch: {
  }
}
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}

*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
	font-family: PingFangSC-Regular;
}

a {
  text-decoration: none;
  color: #333;
}
html,body {
  scroll-behavior: smooth; /* 平滑滚动 */
}

#app {
  font-family: PingFangSC-Regular, Microsoft YaHei, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.app-menu-pc {
  // border: 1px solid #ccc;
  .page_logo {
    z-index: 100;
    position: absolute;
    top: 40px;
    left: 40px;
    img {
      width: 160px;
    }
  }

  .page_right_top_menu {
    z-index: 100;
    position: absolute;
    right: 40px;
    top: 0px;
    img {
      width: 90px;
    }
  }
}

.page-menu-mask {
  background: #7b1b1f;
  background: url("./assets/img/pc/menubj.png");
  background-size: 100%;
  width: 380px;
  position: absolute;
  z-index: 200;
  top: 0;
  right: 0;
  bottom: 0;
  transform: 0.5s 0.5s;
  transition: width .5s linear;
  color: red;
  .menu-close {
    margin-top: 40px;
    float: right;
    margin-right: 55px;
    img {
      width: 30px;
    }
  }
  ul {
    margin-top: 120px;
    // border: 1px solid red;
    margin-left: 30px;
    li {
      list-style: none;
      padding: 12px 10px;
      position: relative;
      a {
        color: #8b5154;
        font-size: 18px;
        text-decoration: none;
        padding-left: 20px;
        &:hover {
          color: #fffefe;
          &::after {
            width: 12px;
            border: 1px solid #fffefe;
            position: absolute;
            content: " ";
            left: 0 ;
            top: 24px;
            font-weight: bold;
          }
        }
      }
    }
    .li-active {
      a {
        color: #fffefe;
        &::after {
          width: 12px;
          border: 1px solid #fffefe;
          position: absolute;
          content: " ";
          left: 0 ;
          top: 24px;
          font-weight: bold;
        }
      }
    }
  }
}



.app-menu-mobile {
  // border: 1px solid #ccc;
  .page_logo {
    z-index: 100;
    position: absolute;
    top: 20px;
    left: 50%;
    margin-left: -4rem;
    img {
      width: 8rem;
    }
  }

  .page_right_top_menu {
    z-index: 100;
    position: absolute;
    right: 10px;
    top: 20px;
    img {
      width: 3.5rem;
    }
  }

  .page-menu-mask {
    width: 200px;
    background: #7b1b1f;
    a {
      padding-left: 0;
    }
    a::after {
      display: none;
    }
  }
}

.font_normal {
  font-size: 16px;
}

.fc_red {
  color: #7a1b20;
}

.fs_16 {
  font-size: 16px;
}

.fs_18 {
  font-size: 18px;
}

.fs_24 {
  font-size: 24px;
}


#page_logo {
  z-index: 100;
  position: absolute;
  top: 40px;
  left: 40px;
  img {
    width: 160px;
  }
}

#page_right_top_menu {
  z-index: 100;
  position: absolute;
  right: 40px;

  img {
    width: 90px;
  }
}



#page_menu {
  position: absolute;
  z-index: 100;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  color: red;

  li {
    list-style: none;
    padding: 12px 10px;
    margin-right: -3px;

    a {
      font-size: 14px;
      text-decoration: none;
    }
  }
}


.page_menu_white {
  border-right: 1px solid white;

  a {
    color: #fff;
  }

  li.active {
    border-right: 2px solid white;
  }

}


.page_menu_red {
  border-right: 1px solid #7a1b20;

  a {
    color: #7a1b20;
  }

  li.active {
    border-right: 2px solid #7a1b20;
  }
}

/* end menu */
.footer {
  background: red;
}
.app-footer {
  text-align: center;
	font-size: 15px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 47px;
	letter-spacing: 2px;
	// color: #3a3a3a;
  background: #292d33;
  // margin-top: 50px;
  a {
    text-decoration: none;
    color: #9b9b9b;
  }
}




.app-footer-contact-page {
  background: #741c22;
  margin-top: 0;
  a {
    color: #fff;
  }
}


</style>



// WEBPACK FOOTER //
// App.vue?05fbbc00